module.exports = __webpack_public_path__ + "img/miaosha1.e8349072.png";